import Icon from 'src/components/Icon';

type Props = {
  children: JSX.Element | JSX.Element[];
  value: number;
  setValue: (value: string) => void;
};

export default function AccountAgreeDropDown({ value, setValue, children }: Props): JSX.Element {
  return (
    <div className="relative flex items-center justify-end">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={['N_12_R', 'max-h-5', 'pr-6', 'w-full', 'appearance-none', 'bg-white'].join(' ')}
      >
        {children}
      </select>
      <Icon name="down" size="20" className="absolute pointer-events-none"></Icon>
    </div>
  );
}

// export function useSelectBox(options?: Partial<Props>) {
//   const [value, setValue] = useState('');
//   const [validState, setValidState] = useState(VALID_STATE.NONE);
//   const [errorMessage, setErrorMessage] = useState('');

//   return {
//     value,
//     isValid: validState === VALID_STATE.PASS,
//     options: {
//       name: '',
//       value,
//       setValue,
//       validState,
//       setValidState,
//       errorMessage,
//       setErrorMessage,
//       ...(options || {}),
//     },
//   };
// }
